/* eslint-disable tailwindcss/no-arbitrary-value */

import { staticText } from 'utils/staticText';
import { LoginStaticText } from '$/(login)/i18n';

export const FaqStaticText = staticText({
  faqHeading: {
    _: 'Questions & Answers',
    'zh-hk': '常見問答',
  },
  faqContent: {
    _: [
      {
        question: 'How does it work?',
        answer: (
          <ul className="ml-5 list-outside list-decimal">
            <li>
              Continue with Google or email on this page, buy or apply for the
              product, receive claim reward email, and submit the claim form.
            </li>
            <li>Use the link shown on this page to apply for the product.</li>
            <li>Turn off AdBlocker or incognito mode before applying.</li>
            <li>
              Avoid using the back button or refreshing the page to prevent data
              loss.
            </li>
          </ul>
        ),
      },
    ],
  },
  faqContent_8755: {
    // Loan Citibank
    _: [
      {
        question: 'How do I qualify for these rewards?',
        answer: (
          <ul className="ml-5 list-outside list-decimal">
            <li>
              Sign up / Log in : Continue with Google or email on this page to
              commence your application process
            </li>
            <li>
              Apply: Upon logging in, you will be directed to the application
              form on the Citibank website
            </li>
            <li>
              Submit: Submit the SingSaver Rewards Redemption Form with your
              Application Reference Number received during your application
              process
            </li>
          </ul>
        ),
      },
      {
        question: 'Why is this the best offer?',
        answer: (
          <ul className="ml-5 list-outside list-decimal">
            <li>Flexible line of credit</li>
            <li>No processing fees</li>
          </ul>
        ),
      },
      {
        question: 'Once my application is approved, how can I claim my reward?',
        answer: `You will receive an email notification with instructions on how to redeem your rewards within (3) calendar months from the date of completion of all promotion criteria`,
      },
      {
        question:
          'If I cancel/withdraw my purchase/application before the campaign end date/redemption date, will I still be eligible?',
        answer: `No, you will not be eligible. You must ensure your application is not withdrawn or canceled during this promotion period.`,
      },
    ],
  },
  faqContent_9195: {
    // Loan Trust Bank
    _: [
      {
        question: 'How do I qualify for these rewards?',
        answer: (
          <ul className="ml-5 list-outside list-decimal">
            <li>
              Sign up / Log in : Continue with Google or email on this page to
              commence your application process
            </li>
            <li>
              Apply: Upon logging in, you will be directed to the application
              form on the Trust Bank’s website
            </li>
            <li>
              Submit: Submit the SingSaver Rewards Redemption Form with your
              Application Reference Number received during your application
              process
            </li>
          </ul>
        ),
      },
      {
        question: 'Why is this the best offer?',
        answer: (
          <ul className="ml-5 list-outside list-decimal">
            <li>Flexible repayment</li>
            <li>Get your loan approved as fast as 3 minutes</li>
          </ul>
        ),
      },
      {
        question: 'Once my application is approved, how can I claim my reward?',
        answer: `You will receive an email notification with instructions on how to redeem your rewards within (3) calendar months from the date of completion of all promotion criteria`,
      },
      {
        question:
          'If I cancel/withdraw my purchase/application before the campaign end date/redemption date, will I still be eligible?',
        answer: `No, you will not be eligible. You must ensure your application is not withdrawn or canceled during this promotion period.`,
      },
    ],
  },
  faqContent_9335: {
    // Loan HSBC
    _: [
      {
        question: 'How do I qualify for these rewards?',
        answer: (
          <ul className="ml-5 list-outside list-decimal">
            <li>
              Sign up / Log in : Continue with Google or email on this page to
              commence your application process
            </li>
            <li>
              Apply: Upon logging in, you will be directed to the application
              form on the HSBC website
            </li>
            <li>
              Submit: Submit the SingSaver Rewards Redemption Form with your
              Application Reference Number received during your application
              process
            </li>
          </ul>
        ),
      },
      {
        question: 'Why is this the best offer?',
        answer: (
          <ul className="ml-5 list-outside list-decimal">
            <li>
              Longest repayment period of up to 7 years, as low as S$15 every
              month
            </li>
            <li>Enjoy Instant Cash upon approval</li>
          </ul>
        ),
      },
      {
        question: 'Once my application is approved, how can I claim my reward?',
        answer: `You will receive an email notification with instructions on how to redeem your rewards within (3) calendar months from the date of completion of all promotion criteria`,
      },
      {
        question:
          'If I cancel/withdraw my purchase/application before the campaign end date/redemption date, will I still be eligible?',
        answer: `No, you will not be eligible. You must ensure your application is not withdrawn or canceled during this promotion period.`,
      },
    ],
  },
  faqContent_8998: {
    // Loan Standard Chartered
    _: [
      {
        question: 'How do I qualify for these rewards?',
        answer: (
          <ul className="ml-5 list-outside list-decimal">
            <li>
              Sign up / Log in : Continue with Google or email on this page to
              commence your application process
            </li>
            <li>
              Apply: Upon logging in, you will be directed to the application
              form on the Standard Chartered website
            </li>
            <li>
              Submit: Submit the SingSaver Rewards Redemption Form with your
              Application Reference Number received during your application
              process
            </li>
          </ul>
        ),
      },
      {
        question: 'Why is this the best offer?',
        answer:
          'Instant cash disbursement into any bank account (subject to loan approval)',
      },
      {
        question: 'Once my application is approved, how can I claim my reward?',
        answer: `You will receive an email notification with instructions on how to redeem your rewards within (3) calendar months from the date of completion of all promotion criteria`,
      },
      {
        question:
          'If I cancel/withdraw my purchase/application before the campaign end date/redemption date, will I still be eligible?',
        answer: `No, you will not be eligible. You must ensure your application is not withdrawn or canceled during this promotion period.`,
      },
    ],
  },
  faqContent_9336: {
    // Loan UOB
    _: [
      {
        question: 'How do I qualify for these rewards?',
        answer: (
          <ul className="ml-5 list-outside list-decimal">
            <li>
              Sign up / Log in : Continue with Google or email on this page to
              commence your application process
            </li>
            <li>
              Apply: Upon logging in, you will be directed to the application
              form on the UOB website
            </li>
            <li>
              Submit: Submit the SingSaver Rewards Redemption Form with your
              Application Reference Number received during your application
              process
            </li>
          </ul>
        ),
      },
      {
        question: 'Why is this the best offer?',
        answer: (
          <ul className="ml-5 list-outside list-decimal">
            <li>
              Get instant approval and cash disbursed into your UOB accounts for
              applications submitted between 8am and 9pm
            </li>
            <li>No processing fees</li>
          </ul>
        ),
      },
      {
        question: 'Once my application is approved, how can I claim my reward?',
        answer: `You will receive an email notification with instructions on how to redeem your rewards within (3) calendar months from the date of completion of all promotion criteria`,
      },
      {
        question:
          'If I cancel/withdraw my purchase/application before the campaign end date/redemption date, will I still be eligible?',
        answer: `No, you will not be eligible. You must ensure your application is not withdrawn or canceled during this promotion period.`,
      },
    ],
  },
  faqContent_9007: {
    // Loan CIMB
    _: [
      {
        question: 'How do I qualify for these rewards?',
        answer: (
          <ul className="ml-5 list-outside list-decimal">
            <li>
              Sign up / Log in : Continue with Google or email on this page to
              commence your application process
            </li>
            <li>
              Apply: Upon logging in, you will be directed to the application
              form on the CIMB website
            </li>
            <li>
              Submit: Submit the SingSaver Rewards Redemption Form with your
              Application Reference Number received during your application
              process
            </li>
          </ul>
        ),
      },
      {
        question: 'Why is this the best offer?',
        answer: (
          <ul className="ml-5 list-outside list-decimal">
            <li>Instant approval</li>
            <li>Open to Malaysians with simple application procedure</li>
          </ul>
        ),
      },
      {
        question: 'Once my application is approved, how can I claim my reward?',
        answer: `You will receive an email notification with instructions on how to redeem your rewards within (3) calendar months from the date of completion of all promotion criteria`,
      },
      {
        question:
          'If I cancel/withdraw my purchase/application before the campaign end date/redemption date, will I still be eligible?',
        answer: `No, you will not be eligible. You must ensure your application is not withdrawn or canceled during this promotion period.`,
      },
    ],
  },
  faqContent_9278: {
    _: [
      {
        question: (
          <>
            How will winners be selected for this <b>Lightning Deal</b>{' '}
            promotion?
          </>
        ),
        answer: (
          <ul className="ml-5">
            <li className="mb-2">
              Winners for the Credit Card Madness Deal promotion will be chosen
              based on the Fastest Fingers First mechanic. Throughout the
              campaign period (March 14th to March 23rd, 2025), there will be 5
              winners per timeslot, resulting in a total of 10 winners daily.
            </li>
            <li className="mb-2">
              The first 10 eligible applicants during each timeslot will secure
              the Madness Deal rewards, which include exciting prizes such as
              the iPhone 16 and iPad Air 11&apos; + Apple Pencil.
            </li>
            <li className="mb-2">
              To qualify, applicants must:<br></br>- Apply for an eligible
              credit card through SingSaver within the designated timeslots.
              <br></br>- Meet all product and promotion eligibility criteria,
              including application approval by the financial institution.
            </li>
            <li className="mb-2">
              The selection process will be conducted fairly and transparently,
              with all reward fulfillment managed according to the Terms &
              Conditions of the campaign. Winners will receive the Madness Deal
              rewards instead of the ongoing SingSaver-exclusive provider
              promotions.
            </li>
          </ul>
        ),
      },
      {
        question: (
          <>
            Will the reward from the <b>Lightning Deal</b> promotion be in
            addition to the credit card&apos;s base exclusive offer?
          </>
        ),
        answer:
          'No, this Madness Deal rewards will replace the ongoing SingSaver-exclusive provider promotions. With 5 winners per timeslot and 10 winners daily, make sure you apply quickly to secure your spot.',
      },
      {
        question: (
          <>
            What must I do to be eligible for the{' '}
            <b>March Madness Spin the Wheel</b>?
          </>
        ),
        answer: (
          <ul className="ml-5 list-outside list-decimal">
            To qualify for this promotion, follow these steps below.<br></br>
            <li>
              Apply for an eligible credit cards<br></br>
              Submit an application for an eligible credit card between March
              3rd, 2025, 09:00 and March 31st, 2025, 23:59 through SingSaver.
              You must also create a SingSaver account and provide marketing
              consent as part of the application process.
            </li>
            <li>
              Meet both product and promotion eligibility criteria<br></br>
              Your application must be approved by the financial institution.
              Ensure you meet any minimum income or age requirements specified
              by the credit card provider. Please ensure you have reviewed
              promotions that may require card activation and a minimum spend
              within a set timeframe.
            </li>
            <li>
              Submit your Rewards Redemption Form<br></br>
              After applying, complete the Rewards Redemption Form, which will
              be sent to your registered email. Fill out the form with your full
              name (as per NRIC) and submit it within 14 days of application OR
              before the campaign end date, whichever is earlier.
            </li>
            <li>
              Wait for our notification<br></br>
              SingSaver will inform you via email about your eligibility for
              rewards. Check your spam or junk mail to ensure you receive this
              communication,
              <br></br>
              <br></br>
              Refer to the full Terms & Conditions
              <a
                href="https://singsaver.link/mm2025-tncs"
                target="_blank"
                rel="noreferrer"
              >
                here
              </a>
              .
            </li>
          </ul>
        ),
      },
      {
        question: (
          <>
            Will the rewards from <b>March Madness Spin the Wheel</b> be in
            addition to the credit card&apos;s base exclusive offer?
          </>
        ),
        answer:
          'Yes, the rewards won from March Madness Spin the Wheel will be on top of the ongoing SingSaver exclusive provider promotions.',
      },
      {
        question: 'How can I claim my reward?',
        answer: (
          <>
            <ul className="ml-5 list-outside list-decimal">
              <li>
                For SingSaver Credit Card Exclusive Offers:<br></br>
                You will receive an email notification with instructions on how
                to redeem your reward within three (3) calendar months from the
                date of completion of all promotion criteria.
              </li>
              <li>
                For March Madness Spin the Wheel Rewards:<br></br>
                You will receive an email notification with redemption
                instructions after completing your spin.<br></br>
                Refer to the full Terms & Conditions here
              </li>
            </ul>
            <br></br>* Check your spam/junk folder to ensure our emails are not
            redirected.<br></br>* Add no-reply@singsaver.com.sg and
            info@singsaver.com.sg to your Safe Sender list.<br></br>* Kindly
            drop an email to info@singsaver.com.sg for any assistance required.
            <br></br>
          </>
        ),
      },
      {
        question:
          'If I cancel or withdraw my application before the campaign ends, will I still be eligible?',
        answer:
          'No. If your application is withdrawn or canceled during the promotion period, you will not be eligible for rewards. You must also maintain marketing consent throughout the campaign.',
      },
    ],
  },
  faqContent_9279: {
    _: [
      {
        question: (
          <>
            How will winners be selected for this <b>Lightning Deal</b>{' '}
            promotion?
          </>
        ),
        answer: (
          <ul className="ml-5">
            <li className="mb-2">
              Winners for the Credit Card Madness Deal promotion will be chosen
              based on the Fastest Fingers First mechanic. Throughout the
              campaign period (March 14th to March 23rd, 2025), there will be 5
              winners per timeslot, resulting in a total of 10 winners daily.
            </li>
            <li className="mb-2">
              The first 10 eligible applicants during each timeslot will secure
              the Madness Deal rewards, which include exciting prizes such as
              the iPhone 16 and iPad Air 11&apos; + Apple Pencil.
            </li>
            <li className="mb-2">
              To qualify, applicants must:<br></br>- Apply for an eligible
              credit card through SingSaver within the designated timeslots.
              <br></br>- Meet all product and promotion eligibility criteria,
              including application approval by the financial institution.
            </li>
            <li className="mb-2">
              The selection process will be conducted fairly and transparently,
              with all reward fulfillment managed according to the Terms &
              Conditions of the campaign. Winners will receive the Madness Deal
              rewards instead of the ongoing SingSaver-exclusive provider
              promotions.
            </li>
          </ul>
        ),
      },
      {
        question: (
          <>
            Will the reward from the <b>Lightning Deal</b> promotion be in
            addition to the credit card&apos;s base exclusive offer?
          </>
        ),
        answer:
          'No, this Madness Deal rewards will replace the ongoing SingSaver-exclusive provider promotions. With 5 winners per timeslot and 10 winners daily, make sure you apply quickly to secure your spot.',
      },
      {
        question: (
          <>
            What must I do to be eligible for the{' '}
            <b>March Madness Spin the Wheel</b>?
          </>
        ),
        answer: (
          <ul className="ml-5 list-outside list-decimal">
            To qualify for this promotion, follow these steps below.<br></br>
            <li>
              Apply for an eligible credit cards<br></br>
              Submit an application for an eligible credit card between March
              3rd, 2025, 09:00 and March 31st, 2025, 23:59 through SingSaver.
              You must also create a SingSaver account and provide marketing
              consent as part of the application process.
            </li>
            <li>
              Meet both product and promotion eligibility criteria<br></br>
              Your application must be approved by the financial institution.
              Ensure you meet any minimum income or age requirements specified
              by the credit card provider. Please ensure you have reviewed
              promotions that may require card activation and a minimum spend
              within a set timeframe.
            </li>
            <li>
              Submit your Rewards Redemption Form<br></br>
              After applying, complete the Rewards Redemption Form, which will
              be sent to your registered email. Fill out the form with your full
              name (as per NRIC) and submit it within 14 days of application OR
              before the campaign end date, whichever is earlier.
            </li>
            <li>
              Wait for our notification<br></br>
              SingSaver will inform you via email about your eligibility for
              rewards. Check your spam or junk mail to ensure you receive this
              communication,
              <br></br>
              <br></br>
              Refer to the full Terms & Conditions
              <a
                href="https://singsaver.link/mm2025-tncs"
                target="_blank"
                rel="noreferrer"
              >
                here
              </a>
              .
            </li>
          </ul>
        ),
      },
      {
        question: (
          <>
            Will the rewards from <b>March Madness Spin the Wheel</b> be in
            addition to the credit card&apos;s base exclusive offer?
          </>
        ),
        answer:
          'Yes, the rewards won from March Madness Spin the Wheel will be on top of the ongoing SingSaver exclusive provider promotions.',
      },
      {
        question: 'How can I claim my reward?',
        answer: (
          <>
            <ul className="ml-5 list-outside list-decimal">
              <li>
                For SingSaver Credit Card Exclusive Offers:<br></br>
                You will receive an email notification with instructions on how
                to redeem your reward within three (3) calendar months from the
                date of completion of all promotion criteria.
              </li>
              <li>
                For March Madness Spin the Wheel Rewards:<br></br>
                You will receive an email notification with redemption
                instructions after completing your spin.<br></br>
                Refer to the full Terms & Conditions here
              </li>
            </ul>
            <br></br>* Check your spam/junk folder to ensure our emails are not
            redirected.<br></br>* Add no-reply@singsaver.com.sg and
            info@singsaver.com.sg to your Safe Sender list.<br></br>* Kindly
            drop an email to info@singsaver.com.sg for any assistance required.
            <br></br>
          </>
        ),
      },
      {
        question:
          'If I cancel or withdraw my application before the campaign ends, will I still be eligible?',
        answer:
          'No. If your application is withdrawn or canceled during the promotion period, you will not be eligible for rewards. You must also maintain marketing consent throughout the campaign.',
      },
    ],
  },
  faqContent_9280: {
    _: [
      {
        question: (
          <>
            How will winners be selected for this <b>Lightning Deal</b>{' '}
            promotion?
          </>
        ),
        answer: (
          <ul className="ml-5">
            <li className="mb-2">
              Winners for the Credit Card Madness Deal promotion will be chosen
              based on the Fastest Fingers First mechanic. Throughout the
              campaign period (March 14th to March 23rd, 2025), there will be 5
              winners per timeslot, resulting in a total of 10 winners daily.
            </li>
            <li className="mb-2">
              The first 10 eligible applicants during each timeslot will secure
              the Madness Deal rewards, which include exciting prizes such as
              the iPhone 16 and iPad Air 11&apos; + Apple Pencil.
            </li>
            <li className="mb-2">
              To qualify, applicants must:<br></br>- Apply for an eligible
              credit card through SingSaver within the designated timeslots.
              <br></br>- Meet all product and promotion eligibility criteria,
              including application approval by the financial institution.
            </li>
            <li className="mb-2">
              The selection process will be conducted fairly and transparently,
              with all reward fulfillment managed according to the Terms &
              Conditions of the campaign. Winners will receive the Madness Deal
              rewards instead of the ongoing SingSaver-exclusive provider
              promotions.
            </li>
          </ul>
        ),
      },
      {
        question: (
          <>
            Will the reward from the <b>Lightning Deal</b> promotion be in
            addition to the credit card&apos;s base exclusive offer?
          </>
        ),
        answer:
          'No, this Madness Deal rewards will replace the ongoing SingSaver-exclusive provider promotions. With 5 winners per timeslot and 10 winners daily, make sure you apply quickly to secure your spot.',
      },
      {
        question: (
          <>
            What must I do to be eligible for the{' '}
            <b>March Madness Spin the Wheel</b>?
          </>
        ),
        answer: (
          <ul className="ml-5 list-outside list-decimal">
            To qualify for this promotion, follow these steps below.<br></br>
            <li>
              Apply for an eligible credit cards<br></br>
              Submit an application for an eligible credit card between March
              3rd, 2025, 09:00 and March 31st, 2025, 23:59 through SingSaver.
              You must also create a SingSaver account and provide marketing
              consent as part of the application process.
            </li>
            <li>
              Meet both product and promotion eligibility criteria<br></br>
              Your application must be approved by the financial institution.
              Ensure you meet any minimum income or age requirements specified
              by the credit card provider. Please ensure you have reviewed
              promotions that may require card activation and a minimum spend
              within a set timeframe.
            </li>
            <li>
              Submit your Rewards Redemption Form<br></br>
              After applying, complete the Rewards Redemption Form, which will
              be sent to your registered email. Fill out the form with your full
              name (as per NRIC) and submit it within 14 days of application OR
              before the campaign end date, whichever is earlier.
            </li>
            <li>
              Wait for our notification<br></br>
              SingSaver will inform you via email about your eligibility for
              rewards. Check your spam or junk mail to ensure you receive this
              communication,
              <br></br>
              <br></br>
              Refer to the full Terms & Conditions
              <a
                href="https://singsaver.link/mm2025-tncs"
                target="_blank"
                rel="noreferrer"
              >
                here
              </a>
              .
            </li>
          </ul>
        ),
      },
      {
        question: (
          <>
            Will the rewards from <b>March Madness Spin the Wheel</b> be in
            addition to the credit card&apos;s base exclusive offer?
          </>
        ),
        answer:
          'Yes, the rewards won from March Madness Spin the Wheel will be on top of the ongoing SingSaver exclusive provider promotions.',
      },
      {
        question: 'How can I claim my reward?',
        answer: (
          <>
            <ul className="ml-5 list-outside list-decimal">
              <li>
                For SingSaver Credit Card Exclusive Offers:<br></br>
                You will receive an email notification with instructions on how
                to redeem your reward within three (3) calendar months from the
                date of completion of all promotion criteria.
              </li>
              <li>
                For March Madness Spin the Wheel Rewards:<br></br>
                You will receive an email notification with redemption
                instructions after completing your spin.<br></br>
                Refer to the full Terms & Conditions here
              </li>
            </ul>
            <br></br>* Check your spam/junk folder to ensure our emails are not
            redirected.<br></br>* Add no-reply@singsaver.com.sg and
            info@singsaver.com.sg to your Safe Sender list.<br></br>* Kindly
            drop an email to info@singsaver.com.sg for any assistance required.
            <br></br>
          </>
        ),
      },
      {
        question:
          'If I cancel or withdraw my application before the campaign ends, will I still be eligible?',
        answer:
          'No. If your application is withdrawn or canceled during the promotion period, you will not be eligible for rewards. You must also maintain marketing consent throughout the campaign.',
      },
    ],
  },
  faqContent_9281: {
    _: [
      {
        question: (
          <>
            How will winners be selected for this <b>Lightning Deal</b>{' '}
            promotion?
          </>
        ),
        answer: (
          <ul className="ml-5">
            <li className="mb-2">
              Winners for the Credit Card Madness Deal promotion will be chosen
              based on the Fastest Fingers First mechanic. Throughout the
              campaign period (March 14th to March 23rd, 2025), there will be 5
              winners per timeslot, resulting in a total of 10 winners daily.
            </li>
            <li className="mb-2">
              The first 10 eligible applicants during each timeslot will secure
              the Madness Deal rewards, which include exciting prizes such as
              the iPhone 16 and iPad Air 11&apos; + Apple Pencil.
            </li>
            <li className="mb-2">
              To qualify, applicants must:<br></br>- Apply for an eligible
              credit card through SingSaver within the designated timeslots.
              <br></br>- Meet all product and promotion eligibility criteria,
              including application approval by the financial institution.
            </li>
            <li className="mb-2">
              The selection process will be conducted fairly and transparently,
              with all reward fulfillment managed according to the Terms &
              Conditions of the campaign. Winners will receive the Madness Deal
              rewards instead of the ongoing SingSaver-exclusive provider
              promotions.
            </li>
          </ul>
        ),
      },
      {
        question: (
          <>
            Will the reward from the <b>Lightning Deal</b> promotion be in
            addition to the credit card&apos;s base exclusive offer?
          </>
        ),
        answer:
          'No, this Madness Deal rewards will replace the ongoing SingSaver-exclusive provider promotions. With 5 winners per timeslot and 10 winners daily, make sure you apply quickly to secure your spot.',
      },
      {
        question: (
          <>
            What must I do to be eligible for the{' '}
            <b>March Madness Spin the Wheel</b>?
          </>
        ),
        answer: (
          <ul className="ml-5 list-outside list-decimal">
            To qualify for this promotion, follow these steps below.<br></br>
            <li>
              Apply for an eligible credit cards<br></br>
              Submit an application for an eligible credit card between March
              3rd, 2025, 09:00 and March 31st, 2025, 23:59 through SingSaver.
              You must also create a SingSaver account and provide marketing
              consent as part of the application process.
            </li>
            <li>
              Meet both product and promotion eligibility criteria<br></br>
              Your application must be approved by the financial institution.
              Ensure you meet any minimum income or age requirements specified
              by the credit card provider. Please ensure you have reviewed
              promotions that may require card activation and a minimum spend
              within a set timeframe.
            </li>
            <li>
              Submit your Rewards Redemption Form<br></br>
              After applying, complete the Rewards Redemption Form, which will
              be sent to your registered email. Fill out the form with your full
              name (as per NRIC) and submit it within 14 days of application OR
              before the campaign end date, whichever is earlier.
            </li>
            <li>
              Wait for our notification<br></br>
              SingSaver will inform you via email about your eligibility for
              rewards. Check your spam or junk mail to ensure you receive this
              communication,
              <br></br>
              <br></br>
              Refer to the full Terms & Conditions
              <a
                href="https://singsaver.link/mm2025-tncs"
                target="_blank"
                rel="noreferrer"
              >
                here
              </a>
              .
            </li>
          </ul>
        ),
      },
      {
        question: (
          <>
            Will the rewards from <b>March Madness Spin the Wheel</b> be in
            addition to the credit card&apos;s base exclusive offer?
          </>
        ),
        answer:
          'Yes, the rewards won from March Madness Spin the Wheel will be on top of the ongoing SingSaver exclusive provider promotions.',
      },
      {
        question: 'How can I claim my reward?',
        answer: (
          <>
            <ul className="ml-5 list-outside list-decimal">
              <li>
                For SingSaver Credit Card Exclusive Offers:<br></br>
                You will receive an email notification with instructions on how
                to redeem your reward within three (3) calendar months from the
                date of completion of all promotion criteria.
              </li>
              <li>
                For March Madness Spin the Wheel Rewards:<br></br>
                You will receive an email notification with redemption
                instructions after completing your spin.<br></br>
                Refer to the full Terms & Conditions here
              </li>
            </ul>
            <br></br>* Check your spam/junk folder to ensure our emails are not
            redirected.<br></br>* Add no-reply@singsaver.com.sg and
            info@singsaver.com.sg to your Safe Sender list.<br></br>* Kindly
            drop an email to info@singsaver.com.sg for any assistance required.
            <br></br>
          </>
        ),
      },
      {
        question:
          'If I cancel or withdraw my application before the campaign ends, will I still be eligible?',
        answer:
          'No. If your application is withdrawn or canceled during the promotion period, you will not be eligible for rewards. You must also maintain marketing consent throughout the campaign.',
      },
    ],
  },
  faqContent_9391: {
    _: [
      {
        question: (
          <>
            How will winners be selected for this <b>Lightning Deal</b>{' '}
            promotion?
          </>
        ),
        answer: (
          <ul className="ml-5">
            <li className="mb-2">
              Winners for the Credit Card Madness Deal promotion will be chosen
              based on the Fastest Fingers First mechanic. Throughout the
              campaign period (March 14th to March 23rd, 2025), there will be 5
              winners per timeslot, resulting in a total of 10 winners daily.
            </li>
            <li className="mb-2">
              The first 10 eligible applicants during each timeslot will secure
              the Madness Deal rewards, which include exciting prizes such as
              the iPhone 16 and iPad Air 11&apos; + Apple Pencil.
            </li>
            <li className="mb-2">
              To qualify, applicants must:<br></br>- Apply for an eligible
              credit card through SingSaver within the designated timeslots.
              <br></br>- Meet all product and promotion eligibility criteria,
              including application approval by the financial institution.
            </li>
            <li className="mb-2">
              The selection process will be conducted fairly and transparently,
              with all reward fulfillment managed according to the Terms &
              Conditions of the campaign. Winners will receive the Madness Deal
              rewards instead of the ongoing SingSaver-exclusive provider
              promotions.
            </li>
          </ul>
        ),
      },
      {
        question: (
          <>
            Will the reward from the <b>Lightning Deal</b> promotion be in
            addition to the credit card&apos;s base exclusive offer?
          </>
        ),
        answer:
          'No, this Madness Deal rewards will replace the ongoing SingSaver-exclusive provider promotions. With 5 winners per timeslot and 10 winners daily, make sure you apply quickly to secure your spot.',
      },
      {
        question: (
          <>
            What must I do to be eligible for the{' '}
            <b>March Madness Spin the Wheel</b>?
          </>
        ),
        answer: (
          <ul className="ml-5 list-outside list-decimal">
            To qualify for this promotion, follow these steps below.<br></br>
            <li>
              Apply for an eligible credit cards<br></br>
              Submit an application for an eligible credit card between March
              3rd, 2025, 09:00 and March 31st, 2025, 23:59 through SingSaver.
              You must also create a SingSaver account and provide marketing
              consent as part of the application process.
            </li>
            <li>
              Meet both product and promotion eligibility criteria<br></br>
              Your application must be approved by the financial institution.
              Ensure you meet any minimum income or age requirements specified
              by the credit card provider. Please ensure you have reviewed
              promotions that may require card activation and a minimum spend
              within a set timeframe.
            </li>
            <li>
              Submit your Rewards Redemption Form<br></br>
              After applying, complete the Rewards Redemption Form, which will
              be sent to your registered email. Fill out the form with your full
              name (as per NRIC) and submit it within 14 days of application OR
              before the campaign end date, whichever is earlier.
            </li>
            <li>
              Wait for our notification<br></br>
              SingSaver will inform you via email about your eligibility for
              rewards. Check your spam or junk mail to ensure you receive this
              communication,
              <br></br>
              <br></br>
              Refer to the full Terms & Conditions
              <a
                href="https://singsaver.link/mm2025-tncs"
                target="_blank"
                rel="noreferrer"
              >
                here
              </a>
              .
            </li>
          </ul>
        ),
      },
      {
        question: (
          <>
            Will the rewards from <b>March Madness Spin the Wheel</b> be in
            addition to the credit card&apos;s base exclusive offer?
          </>
        ),
        answer:
          'Yes, the rewards won from March Madness Spin the Wheel will be on top of the ongoing SingSaver exclusive provider promotions.',
      },
      {
        question: 'How can I claim my reward?',
        answer: (
          <>
            <ul className="ml-5 list-outside list-decimal">
              <li>
                For SingSaver Credit Card Exclusive Offers:<br></br>
                You will receive an email notification with instructions on how
                to redeem your reward within three (3) calendar months from the
                date of completion of all promotion criteria.
              </li>
              <li>
                For March Madness Spin the Wheel Rewards:<br></br>
                You will receive an email notification with redemption
                instructions after completing your spin.<br></br>
                Refer to the full Terms & Conditions here
              </li>
            </ul>
            <br></br>* Check your spam/junk folder to ensure our emails are not
            redirected.<br></br>* Add no-reply@singsaver.com.sg and
            info@singsaver.com.sg to your Safe Sender list.<br></br>* Kindly
            drop an email to info@singsaver.com.sg for any assistance required.
            <br></br>
          </>
        ),
      },
      {
        question:
          'If I cancel or withdraw my application before the campaign ends, will I still be eligible?',
        answer:
          'No. If your application is withdrawn or canceled during the promotion period, you will not be eligible for rewards. You must also maintain marketing consent throughout the campaign.',
      },
    ],
  },
  faqContent_9392: {
    _: [
      {
        question: (
          <>
            How will winners be selected for this <b>Lightning Deal</b>{' '}
            promotion?
          </>
        ),
        answer: (
          <ul className="ml-5">
            <li className="mb-2">
              Winners for the Credit Card Madness Deal promotion will be chosen
              based on the Fastest Fingers First mechanic. Throughout the
              campaign period (March 14th to March 23rd, 2025), there will be 5
              winners per timeslot, resulting in a total of 10 winners daily.
            </li>
            <li className="mb-2">
              The first 10 eligible applicants during each timeslot will secure
              the Madness Deal rewards, which include exciting prizes such as
              the iPhone 16 and iPad Air 11&apos; + Apple Pencil.
            </li>
            <li className="mb-2">
              To qualify, applicants must:<br></br>- Apply for an eligible
              credit card through SingSaver within the designated timeslots.
              <br></br>- Meet all product and promotion eligibility criteria,
              including application approval by the financial institution.
            </li>
            <li className="mb-2">
              The selection process will be conducted fairly and transparently,
              with all reward fulfillment managed according to the Terms &
              Conditions of the campaign. Winners will receive the Madness Deal
              rewards instead of the ongoing SingSaver-exclusive provider
              promotions.
            </li>
          </ul>
        ),
      },
      {
        question: (
          <>
            Will the reward from the <b>Lightning Deal</b> promotion be in
            addition to the credit card&apos;s base exclusive offer?
          </>
        ),
        answer:
          'No, this Madness Deal rewards will replace the ongoing SingSaver-exclusive provider promotions. With 5 winners per timeslot and 10 winners daily, make sure you apply quickly to secure your spot.',
      },
      {
        question: (
          <>
            What must I do to be eligible for the{' '}
            <b>March Madness Spin the Wheel</b>?
          </>
        ),
        answer: (
          <ul className="ml-5 list-outside list-decimal">
            To qualify for this promotion, follow these steps below.<br></br>
            <li>
              Apply for an eligible credit cards<br></br>
              Submit an application for an eligible credit card between March
              3rd, 2025, 09:00 and March 31st, 2025, 23:59 through SingSaver.
              You must also create a SingSaver account and provide marketing
              consent as part of the application process.
            </li>
            <li>
              Meet both product and promotion eligibility criteria<br></br>
              Your application must be approved by the financial institution.
              Ensure you meet any minimum income or age requirements specified
              by the credit card provider. Please ensure you have reviewed
              promotions that may require card activation and a minimum spend
              within a set timeframe.
            </li>
            <li>
              Submit your Rewards Redemption Form<br></br>
              After applying, complete the Rewards Redemption Form, which will
              be sent to your registered email. Fill out the form with your full
              name (as per NRIC) and submit it within 14 days of application OR
              before the campaign end date, whichever is earlier.
            </li>
            <li>
              Wait for our notification<br></br>
              SingSaver will inform you via email about your eligibility for
              rewards. Check your spam or junk mail to ensure you receive this
              communication,
              <br></br>
              <br></br>
              Refer to the full Terms & Conditions
              <a
                href="https://singsaver.link/mm2025-tncs"
                target="_blank"
                rel="noreferrer"
              >
                here
              </a>
              .
            </li>
          </ul>
        ),
      },
      {
        question: (
          <>
            Will the rewards from <b>March Madness Spin the Wheel</b> be in
            addition to the credit card&apos;s base exclusive offer?
          </>
        ),
        answer:
          'Yes, the rewards won from March Madness Spin the Wheel will be on top of the ongoing SingSaver exclusive provider promotions.',
      },
      {
        question: 'How can I claim my reward?',
        answer: (
          <>
            <ul className="ml-5 list-outside list-decimal">
              <li>
                For SingSaver Credit Card Exclusive Offers:<br></br>
                You will receive an email notification with instructions on how
                to redeem your reward within three (3) calendar months from the
                date of completion of all promotion criteria.
              </li>
              <li>
                For March Madness Spin the Wheel Rewards:<br></br>
                You will receive an email notification with redemption
                instructions after completing your spin.<br></br>
                Refer to the full Terms & Conditions here
              </li>
            </ul>
            <br></br>* Check your spam/junk folder to ensure our emails are not
            redirected.<br></br>* Add no-reply@singsaver.com.sg and
            info@singsaver.com.sg to your Safe Sender list.<br></br>* Kindly
            drop an email to info@singsaver.com.sg for any assistance required.
            <br></br>
          </>
        ),
      },
      {
        question:
          'If I cancel or withdraw my application before the campaign ends, will I still be eligible?',
        answer:
          'No. If your application is withdrawn or canceled during the promotion period, you will not be eligible for rewards. You must also maintain marketing consent throughout the campaign.',
      },
    ],
  },
  faqContent_9393: {
    _: [
      {
        question: (
          <>
            How will winners be selected for this <b>Lightning Deal</b>{' '}
            promotion?
          </>
        ),
        answer: (
          <ul className="ml-5">
            <li className="mb-2">
              Winners for the Credit Card Madness Deal promotion will be chosen
              based on the Fastest Fingers First mechanic. Throughout the
              campaign period (March 14th to March 23rd, 2025), there will be 5
              winners per timeslot, resulting in a total of 10 winners daily.
            </li>
            <li className="mb-2">
              The first 10 eligible applicants during each timeslot will secure
              the Madness Deal rewards, which include exciting prizes such as
              the iPhone 16 and iPad Air 11&apos; + Apple Pencil.
            </li>
            <li className="mb-2">
              To qualify, applicants must:<br></br>- Apply for an eligible
              credit card through SingSaver within the designated timeslots.
              <br></br>- Meet all product and promotion eligibility criteria,
              including application approval by the financial institution.
            </li>
            <li className="mb-2">
              The selection process will be conducted fairly and transparently,
              with all reward fulfillment managed according to the Terms &
              Conditions of the campaign. Winners will receive the Madness Deal
              rewards instead of the ongoing SingSaver-exclusive provider
              promotions.
            </li>
          </ul>
        ),
      },
      {
        question: (
          <>
            Will the reward from the <b>Lightning Deal</b> promotion be in
            addition to the credit card&apos;s base exclusive offer?
          </>
        ),
        answer:
          'No, this Madness Deal rewards will replace the ongoing SingSaver-exclusive provider promotions. With 5 winners per timeslot and 10 winners daily, make sure you apply quickly to secure your spot.',
      },
      {
        question: (
          <>
            What must I do to be eligible for the{' '}
            <b>March Madness Spin the Wheel</b>?
          </>
        ),
        answer: (
          <ul className="ml-5 list-outside list-decimal">
            To qualify for this promotion, follow these steps below.<br></br>
            <li>
              Apply for an eligible credit cards<br></br>
              Submit an application for an eligible credit card between March
              3rd, 2025, 09:00 and March 31st, 2025, 23:59 through SingSaver.
              You must also create a SingSaver account and provide marketing
              consent as part of the application process.
            </li>
            <li>
              Meet both product and promotion eligibility criteria<br></br>
              Your application must be approved by the financial institution.
              Ensure you meet any minimum income or age requirements specified
              by the credit card provider. Please ensure you have reviewed
              promotions that may require card activation and a minimum spend
              within a set timeframe.
            </li>
            <li>
              Submit your Rewards Redemption Form<br></br>
              After applying, complete the Rewards Redemption Form, which will
              be sent to your registered email. Fill out the form with your full
              name (as per NRIC) and submit it within 14 days of application OR
              before the campaign end date, whichever is earlier.
            </li>
            <li>
              Wait for our notification<br></br>
              SingSaver will inform you via email about your eligibility for
              rewards. Check your spam or junk mail to ensure you receive this
              communication,
              <br></br>
              <br></br>
              Refer to the full Terms & Conditions
              <a
                href="https://singsaver.link/mm2025-tncs"
                target="_blank"
                rel="noreferrer"
              >
                here
              </a>
              .
            </li>
          </ul>
        ),
      },
      {
        question: (
          <>
            Will the rewards from <b>March Madness Spin the Wheel</b> be in
            addition to the credit card&apos;s base exclusive offer?
          </>
        ),
        answer:
          'Yes, the rewards won from March Madness Spin the Wheel will be on top of the ongoing SingSaver exclusive provider promotions.',
      },
      {
        question: 'How can I claim my reward?',
        answer: (
          <>
            <ul className="ml-5 list-outside list-decimal">
              <li>
                For SingSaver Credit Card Exclusive Offers:<br></br>
                You will receive an email notification with instructions on how
                to redeem your reward within three (3) calendar months from the
                date of completion of all promotion criteria.
              </li>
              <li>
                For March Madness Spin the Wheel Rewards:<br></br>
                You will receive an email notification with redemption
                instructions after completing your spin.<br></br>
                Refer to the full Terms & Conditions here
              </li>
            </ul>
            <br></br>* Check your spam/junk folder to ensure our emails are not
            redirected.<br></br>* Add no-reply@singsaver.com.sg and
            info@singsaver.com.sg to your Safe Sender list.<br></br>* Kindly
            drop an email to info@singsaver.com.sg for any assistance required.
            <br></br>
          </>
        ),
      },
      {
        question:
          'If I cancel or withdraw my application before the campaign ends, will I still be eligible?',
        answer:
          'No. If your application is withdrawn or canceled during the promotion period, you will not be eligible for rewards. You must also maintain marketing consent throughout the campaign.',
      },
    ],
  },
  faqContent_6884: {
    _: [
      {
        question: (
          <>
            How will winners be selected for this <b>Lightning Deal</b>{' '}
            promotion?
          </>
        ),
        answer: (
          <ul className="ml-5">
            <li className="mb-2">
              Winners for the Credit Card Madness Deal promotion will be chosen
              based on the Fastest Fingers First mechanic. Throughout the
              campaign period (March 14th to March 23rd, 2025), there will be 5
              winners per timeslot, resulting in a total of 10 winners daily.
            </li>
            <li className="mb-2">
              The first 10 eligible applicants during each timeslot will secure
              the Madness Deal rewards, which include exciting prizes such as
              the iPhone 16 and iPad Air 11&apos; + Apple Pencil.
            </li>
            <li className="mb-2">
              To qualify, applicants must:<br></br>- Apply for an eligible
              credit card through SingSaver within the designated timeslots.
              <br></br>- Meet all product and promotion eligibility criteria,
              including application approval by the financial institution.
            </li>
            <li className="mb-2">
              The selection process will be conducted fairly and transparently,
              with all reward fulfillment managed according to the Terms &
              Conditions of the campaign. Winners will receive the Madness Deal
              rewards instead of the ongoing SingSaver-exclusive provider
              promotions.
            </li>
          </ul>
        ),
      },
      {
        question: (
          <>
            Will the reward from the <b>Lightning Deal</b> promotion be in
            addition to the credit card&apos;s base exclusive offer?
          </>
        ),
        answer:
          'No, this Madness Deal rewards will replace the ongoing SingSaver-exclusive provider promotions. With 5 winners per timeslot and 10 winners daily, make sure you apply quickly to secure your spot.',
      },
      {
        question: (
          <>
            What must I do to be eligible for the{' '}
            <b>March Madness Spin the Wheel</b>?
          </>
        ),
        answer: (
          <ul className="ml-5 list-outside list-decimal">
            To qualify for this promotion, follow these steps below.<br></br>
            <li>
              Apply for an eligible credit cards<br></br>
              Submit an application for an eligible credit card between March
              3rd, 2025, 09:00 and March 31st, 2025, 23:59 through SingSaver.
              You must also create a SingSaver account and provide marketing
              consent as part of the application process.
            </li>
            <li>
              Meet both product and promotion eligibility criteria<br></br>
              Your application must be approved by the financial institution.
              Ensure you meet any minimum income or age requirements specified
              by the credit card provider. Please ensure you have reviewed
              promotions that may require card activation and a minimum spend
              within a set timeframe.
            </li>
            <li>
              Submit your Rewards Redemption Form<br></br>
              After applying, complete the Rewards Redemption Form, which will
              be sent to your registered email. Fill out the form with your full
              name (as per NRIC) and submit it within 14 days of application OR
              before the campaign end date, whichever is earlier.
            </li>
            <li>
              Wait for our notification<br></br>
              SingSaver will inform you via email about your eligibility for
              rewards. Check your spam or junk mail to ensure you receive this
              communication,
              <br></br>
              <br></br>
              Refer to the full Terms & Conditions
              <a
                href="https://singsaver.link/mm2025-tncs"
                target="_blank"
                rel="noreferrer"
              >
                here
              </a>
              .
            </li>
          </ul>
        ),
      },
      {
        question: (
          <>
            Will the rewards from <b>March Madness Spin the Wheel</b> be in
            addition to the credit card&apos;s base exclusive offer?
          </>
        ),
        answer:
          'Yes, the rewards won from March Madness Spin the Wheel will be on top of the ongoing SingSaver exclusive provider promotions.',
      },
      {
        question: 'How can I claim my reward?',
        answer: (
          <>
            <ul className="ml-5 list-outside list-decimal">
              <li>
                For SingSaver Credit Card Exclusive Offers:<br></br>
                You will receive an email notification with instructions on how
                to redeem your reward within three (3) calendar months from the
                date of completion of all promotion criteria.
              </li>
              <li>
                For March Madness Spin the Wheel Rewards:<br></br>
                You will receive an email notification with redemption
                instructions after completing your spin.<br></br>
                Refer to the full Terms & Conditions here
              </li>
            </ul>
            <br></br>* Check your spam/junk folder to ensure our emails are not
            redirected.<br></br>* Add no-reply@singsaver.com.sg and
            info@singsaver.com.sg to your Safe Sender list.<br></br>* Kindly
            drop an email to info@singsaver.com.sg for any assistance required.
            <br></br>
          </>
        ),
      },
      {
        question:
          'If I cancel or withdraw my application before the campaign ends, will I still be eligible?',
        answer:
          'No. If your application is withdrawn or canceled during the promotion period, you will not be eligible for rewards. You must also maintain marketing consent throughout the campaign.',
      },
    ],
  },
});

export const RewardHeaderStaticText = staticText({
  myRewards: {
    _: {
      text: 'My Rewards',
      link: '/user/account/dashboard',
    },
    'en-hk': {
      text: 'My Rewards',
      link: '/en/user/account/dashboard',
    },
    'zh-hk': {
      text: '我的獎賞',
      link: '/zh/user/account/dashboard',
    },
  },
  referAndEarn: {
    _: {
      text: 'Refer & Earn',
      link: '/user/account/refer-earn',
    },
  },
  helpCenter: {
    _: {
      text: 'Help Center',
      link: 'https://singsaversg.zendesk.com/hc/en-gb',
    },
    'en-hk': {
      text: 'Help Center',
      link: 'https://moneyherohk.zendesk.com/hc/en-gb',
    },
    'zh-hk': {
      text: '幫助中心',
      link: 'https://moneyherohk.zendesk.com/hc/zh-tw',
    },
  },
  logOut: {
    _: 'Log Out',
    'zh-hk': '登出',
  },
});

export const ProductDialogStaticText = staticText({
  dialogSeeMore: {
    _: 'See more',
    'zh-hk': '查看更多',
  },
  dialogSeeLess: {
    _: 'See less',
    'zh-hk': '收起',
  },
  dialogRewardsTitle: {
    _: 'Singsaver Rewards',
    'en-hk': 'MoneyHero Rewards',
    'zh-hk': 'MoneyHero獨家獎賞',
  },
  dialogRewardsDescription: {
    _: 'Description',
    'zh-hk': '描述',
  },
  dialogRewardsOption: {
    _: 'Rewards options',
    'zh-hk': '獨家獎賞選擇',
  },
  dialogRewardsTC: {
    _: 'Terms and conditions',
    'zh-hk': '條款及細則',
  },
  eligibility: {
    _: 'Eligibility',
    'zh-hk': '合資格條件',
  },
  fees: {
    _: 'Fees',
    'zh-hk': '費用',
  },
});

/**
 * Reward copy worded for insurance products.
 *
 * Kept as its own group because the reward offer section is declared twice -
 * once here (rendered by `apply-v2a`) and once in
 * `apply-v2b/[productId]/i18n` - and both have to carry the same insurance
 * wording. The `_` entry repeats today's SingSaver default on purpose: only
 * the HK locales change.
 */
export const RewardOfferInsuranceText = staticText({
  offerSubHeadingINS: {
    _: 'Apply for this ${verticalName} through SingSaver and choose from exciting rewards below.',
    'en-hk':
      'Apply for this ${verticalName} through MoneyHero for a chance to receive an exclusive reward.',
    'zh-hk': '透過 MoneyHero 申請此產品並有機會獲得之獨家獎賞',
  },
});

export const RewardOfferText = staticText({
  offerHeading: {
    _: 'Reward You will Receive',
    'zh-hk': '獎賞',
  },
  offerHeadingDynamic: {
    _: 'Get a Reward Worth Up to ${giftValue}',
    'en-hk': 'Get a Reward Worth Up to ${giftValue}',
    'zh-hk': '獎賞高達${giftValue}',
  },
  offerSubHeading: {
    _: 'Apply for this ${verticalName} through SingSaver and choose from exciting rewards below.',
    'en-hk':
      'Apply for this ${verticalName} through MoneyHero and choose from exciting rewards below.',
    'zh-hk': '透過 MoneyHero 申請此產品並選擇其中一個獨家獎賞',
  },
  offerSeeAll: {
    _: 'See All Rewards & Eligibility',
    'zh-hk': '查看所有獎賞和合資格條件',
  },
  worthText: {
    _: 'Worth ${giftValue}',
    'zh-hk': '價值${giftValue}',
  },
  ...RewardOfferInsuranceText,
  ...ProductDialogStaticText,
});

export const RewardProductText = staticText({
  productHeading: {
    _: 'You are Applying For',
    'zh-hk': '您正在申請',
  },
  productSeeAllDetail: {
    _: 'See All Product Details',
    'zh-hk': '了解更多產品資料',
  },
  viewFullCardsDetails: {
    _: 'View Full Card Details',
    'zh-hk': '了解更多產品資料',
  },
  loanAmountText: {
    _: 'Loan Amount',
    'zh-hk': '貸款額',
  },
  loanTenureText: {
    _: 'Loan Tenure',
    'zh-hk': '還款期',
  },
  loanTenureMonth: {
    _: 'months',
    'zh-hk': '個月',
  },
  processingFeeText: {
    _: 'Processing Fee',
    'zh-hk': '手續費',
  },
  promoCode: {
    _: 'Promo Code',
    'zh-hk': '指定邀請碼',
  },
  copied: {
    _: 'Copied!',
    'zh-hk': '已複製!',
  },
  promoCodeReminderPopupTitle: {
    _: "Don't miss out on your reward!",
    'zh-hk': '別錯過你的獎賞！',
  },
  promoCodeReminderPopupDescription: {
    _: 'To be eligible for your sign-up reward, please copy the promo code below and paste it when submitting your application.',
    'zh-hk': '要符合資格領取註冊獎賞，請複製以下優惠碼，並在提交申請時貼上。',
  },
  promoCodeReminderPopupDismissButton: {
    _: "I'll enter it manually",
    'zh-hk': '我會手動輸入',
  },
  promoCodeReminderPopupCopyButton: {
    _: 'Copy Code & Continue',
    'zh-hk': '複製優惠碼並繼續',
  },
  ...ProductDialogStaticText,
});

export const RewardCopyrightText = staticText({
  toc: {
    _: (
      <a
        href="https://www.singsaver.com.sg/page/singsaver-terms"
        target="_blank"
        rel="noopener noreferrer"
        className="underline"
      >
        Terms & Conditions
      </a>
    ),
    'en-hk': (
      <a
        href="https://www.moneyhero.com.hk/en/page/moneyhero-terms"
        target="_blank"
        rel="noopener noreferrer"
        className="underline"
      >
        Terms & Conditions
      </a>
    ),
    'zh-hk': (
      <a
        href="https://www.moneyhero.com.hk/zh/page/moneyhero-terms"
        target="_blank"
        rel="noopener noreferrer"
        className="underline"
      >
        條款及細則
      </a>
    ),
  },
  privacy: {
    _: (
      <a
        href="https://www.singsaver.com.sg/page/singsaver-privacy-policy"
        target="_blank"
        rel="noopener noreferrer"
        className="underline"
      >
        Privacy Policy
      </a>
    ),
    'en-hk': (
      <a
        href="https://www.moneyhero.com.hk/en/page/moneyhero-privacy-policy"
        target="_blank"
        rel="noopener noreferrer"
        className="underline"
      >
        Privacy Policy
      </a>
    ),
    'zh-hk': (
      <a
        href="https://www.moneyhero.com.hk/zh/page/moneyhero-privacy-policy"
        target="_blank"
        rel="noopener noreferrer"
        className="underline"
      >
        私隱政策
      </a>
    ),
  },
  copyright: {
    _: `© 2021 - ${new Date().getFullYear()}  SingSaver Pte. Ltd. All rights reserved.`,
    'en-hk': `© 2013 - ${new Date().getFullYear()} MoneyHero Global Limited (registered in Hong Kong under company number 1864714) (“MHGL”). All rights reserved.`,
    'zh-hk': `© 2013 - ${new Date().getFullYear()} MoneyHero Global Limited（於香港註冊，公司編號為 1864714）(“MHGL”)`,
  },
});

export const BackupDialog = staticText({
  stickyLoginHeader: {
    _: 'Login with Google or share your email to receive the rewards claim form.',
    'zh-hk': '使用Google帳號或是電子郵件信箱來取得獎賞換領表格',
  },
  didntGetClaimEmail: {
    _: 'Didn’t get the reward claim email?',
    'zh-hk': '沒有收到獎賞換領信件嗎？',
  },
  didntCompleteApplication: {
    _: 'Didn’t complete your application?',
    'zh-hk': '還沒完成你的申請嗎？',
  },
  restartApplication: {
    _: 'Restart the Application',
    'zh-hk': '重新申請',
  },
});

export const RewardStickyFooterText = staticText({
  content: {
    _: 'Secure Your ${verticalName} & Reward Today',
    'zh-hk': '立即申請，獲取獎賞',
  },
  // Insurance wording for the sticky login bar. Each `*INS` key resolves to
  // today's value for every locale except `en-hk` / `zh-hk`, so SingSaver,
  // Moneymax and money101 are unaffected; see `insuranceVerticals.ts` for the
  // vertical codes that select these keys.
  contentINS: {
    _: 'Secure Your ${verticalName} & Reward Today',
    'en-hk':
      'Enter your email to register your reward and continue your application.',
    'zh-hk': '填寫電郵以登記獎賞並繼續投保',
  },
  dialogTitle: {
    _: 'Confirm your contact details to continue with your application and claim your exclusive reward!',
    'zh-hk': '確認您的聯絡資料以領取獨家獎賞！',
  },
  dialogTitleWithPhoneNumberField: {
    _: 'Enter your details to receive your reward and get support with your application.',
    'zh-hk': '請確認您的聯絡資料，以繼續申請流程並領取專屬獎勵',
  },
  dialogSubmitBtn: {
    _: 'Apply now',
    'zh-hk': '確認',
  },
  dialogSeeMore: {
    _: 'see more',
    'zh-hk': '查看更多',
  },
  dialogMarketingConsentShort: {
    _: 'I consent to receiving marketing materials from SingSaver',
    'en-hk': 'I consent to receiving marketing materials from MoneyHero',
    'zh-hk': '我同意接收MoneyHero的營銷材料',
  },
  dialogMarketingConsent: {
    _: (
      <>
        I consent to receiving marketing materials from SingSaver Pte Ltd /
        SingSaver Insurance Brokers Pte Ltd about their products, services,
        offers & events by email, phone call, IM or text as per their{' '}
        <a
          href="https://www.singsaver.com.sg/page/singsaver-privacy-policy"
          className="text-[--text-link] hover:underline"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
        </a>
      </>
    ),
    'en-hk': (
      <>
        I consent to receiving marketing materials from MoneyHero Global Limited
        / MoneyHero Insurance Brokers Limited about their products, services,
        offers & events by email, phone call, IM or text using the personal data
        I have provided as per their{' '}
        <a
          href="https://www.moneyhero.com.hk/en/page/moneyhero-privacy-policy"
          className="text-[--text-link] hover:underline"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
        </a>
        . Opt-out by email to{' '}
        <a
          href="mailto:support@moneyhero.com.hk"
          className="text-[--text-link]"
        >
          support@moneyhero.com.hk
        </a>
      </>
    ),
    'zh-hk': (
      <>
        我同意透過電子郵件、電話、IM或簡訊接收MoneyHero Global Limited /
        MoneyHero Insurance Brokers Limited
        有關其產品、服務、優惠及活動的營銷資料、並使用我根據其
        <a
          href="https://www.moneyhero.com.hk/zh/page/moneyhero-privacy-policy"
          className="text-[--text-link] hover:underline"
          target="_blank"
          rel="noopener noreferrer"
        >
          隱私政策
        </a>
        所提供的個人資料。選擇退出、請發送電子郵件至
        <a
          href="mailto:support@moneyhero.com.hk"
          className="text-[--text-link]"
        >
          support@moneyhero.com.hk
        </a>
      </>
    ),
  },
  dialogTermsAndConditions: {
    _: (
      <>
        By continuing, you agree to SingSaver’s{' '}
        <a
          href="https://www.singsaver.com.sg/page/singsaver-terms"
          className="text-[--text-link] hover:underline"
          target="_blank"
          rel="noreferrer"
        >
          Terms & Conditions
        </a>{' '}
        and{' '}
        <a
          href="https://www.singsaver.com.sg/page/singsaver-privacy-policy"
          className="text-[--text-link] hover:underline"
          target="_blank"
          rel="noreferrer"
        >
          Privacy Policy
        </a>
      </>
    ),
    'en-hk': (
      <>
        By continuing, you agree to MoneyHero’s{' '}
        <a
          href="https://www.moneyhero.com.hk/en/terms"
          className="text-[--text-link] hover:underline"
        >
          Terms & Conditions
        </a>{' '}
        and{' '}
        <a
          href="https://www.moneyhero.com.hk/en/privacy-policy"
          className="text-[--text-link] hover:underline"
        >
          Privacy Policy
        </a>
      </>
    ),
    'zh-hk': (
      <>
        登入或註冊即表示您同意MoneyHero及其關聯公司之
        <a
          href="https://www.moneyhero.com.hk/zh/terms"
          className="text-[--text-link] hover:underline"
        >
          條款及細則
        </a>
        和
        <a
          href="https://www.moneyhero.com.hk/zh/privacy-policy"
          className="text-[--text-link] hover:underline"
        >
          個人私隱政策
        </a>
        。
      </>
    ),
  },
  fieldPhoneNumber: {
    _: {
      title: 'Phone number',
      placeholder: 'e.g: 98765432',
      invalid: 'Please enter a valid phone number.',
      pattern: '^[689][0-9]{7}$',
      tooltip:
        'By providing your phone number, you may be contacted with regards to your application.',
    },
    'en-hk': {
      title: 'Phone number',
      placeholder: 'e.g: 98765432',
      invalid: 'Please enter a valid phone number.',
      pattern: '^[0-9]{8}$',
      tooltip:
        'By providing your phone number, you may be contacted with regards to your application.',
    },
    'zh-hk': {
      title: '聯絡手提電話',
      placeholder: 'e.g: 98765432',
      invalid: '請填入正確的電話格式',
      pattern: '^[0-9]{8}$',
      tooltip: '提供您的電話號碼，以便我們聯絡您有關您的申請。',
    },
  },
  fieldEmail: {
    _: {
      title: 'Email',
      placeholder: 'john.doe@gmail.com',
      pattern: '^[a-zA-Z0-9._%+\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z]{2,}$',
      invalid: 'Please enter a valid email address.',
    },
    'zh-hk': {
      title: '您註冊的電子信箱',
      placeholder: 'john.doe@gmail.com',
      pattern: '^[a-zA-Z0-9._%+\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z]{2,}$',
      invalid: '請輸入有效的電子郵件地址。',
    },
  },
  logoutBtn: {
    _: 'Log out',
    'zh-hk': '登出',
  },
  continueAsBtn: {
    _: 'Continue as ${userEmail}',
    zh: '以${userEmail}繼續',
  },
  continueAsBtnINS: {
    _: 'Continue as ${userEmail}',
    zh: '以${userEmail}繼續',
    'en-hk': 'Register reward and continue as ${userEmail}',
    'zh-hk': '以${userEmail}登記獎賞並繼續',
  },
  // Insurance counterpart of `continueWithEmail` from `LoginStaticText`; that
  // key is shared with the site-wide login and must not be reworded in place.
  continueWithEmailINS: {
    _: 'Continue with Email',
    zh: '登入/註冊',
    'en-hk': 'Register reward and continue',
    'zh-hk': '登記獎賞並繼續',
  },
  ...BackupDialog,
  ...LoginStaticText,
});
